import Vue from "vue";
import Vuex, { Store } from "vuex";
import VuexPersist from 'vuex-persist';

import reports from "@/store/report"
import form from "@/store/form"
import progress from "@/store/progress"
import user from "@/store/user"

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const vuexPersist = new VuexPersist({
  key: 'm2i',
  storage: window.localStorage
})

const store =  new Vuex.Store({
  modules: {
    form,
    reports,
    progress,
    user
  },
  plugins: [vuexPersist.plugin],
  strict: debug
});


export default store;
